<div class="modal" bsModal #modalComponent="bs-modal" tabindex="-1" role="dialog">
  <div class="modal-dialog"  [class.modal-lg]="!config.small" [class.modal-md]="config.small">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left">{{title}}</h4>
        <img *ngIf="config.resizeOrClose==='resize'" src="images/resize.png" alt="[resize]" class="pull-right" style="cursor: pointer;" (click)="resize()"/>
        <img *ngIf="config.resizeOrClose==='close'" src="images/close.png" alt="[close]" class="pull-right" style="cursor: pointer;" (click)="close()"/>
      </div>
      <div class="modal-body">
        <ng-content></ng-content>
      </div>
      <div class="modal-footer">
        <div class="footer-message pull-left">{{config.footerMessage}}</div>
        <div class="modal-buttons">
          <button *ngIf="config.cancelBtnTitle!==''" type="button" [ngClass]="config.cancelBtnCssClass"  (click)="reject()" [innerHTML]="config.cancelBtnTitle"></button>
          <button *ngIf="config.okBtnTitle!==''" type="button" [ngClass]="config.okBtnCssClass"  (click)="accept()" [innerHTML]="config.okBtnTitle"></button>
        </div>
      </div>
    </div>
  </div>
</div>
